import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/serviceBookingsSagas";
import { useDateFormat } from "../../../../hooks/useDateFormat";

export const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();
  const { startDate, endDate } = useSelector((state) => state.serviceBookings.selectedRequestDates);
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.serviceBookings.currentUser
  );
  const future_bookings = useSelector((state) => state.serviceBookings.future_bookings);
  const minDate = useSelector((state) => state.serviceBookings.minDate);
  const maxDate = useSelector((state) => state.serviceBookings.maxDate);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      minDate={future_bookings ? minDate : calendarStartDate}
      calendarEndDate={future_bookings ? maxDate : calendarEndDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};
